import { ref, watch } from "vue-demi";
import { postData } from "@utils";
import { useDebounceFn } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";
import { usePageStore } from "@/stores/pageHeader";
import { mdiMagnify, mdiCalendarClock, mdiUpload } from "@mdi/js";

export function useExpenseTable() {
  const pageStore = usePageStore();
  const toast = useToast();

  // Table
  const tableLoading = ref(true);
  const tableItems = ref([]);
  const tableTotalRec = ref(0);
  const startPage = ref(false);

  // Table Columns
  const tableColumns = ref([
    {
      text: "ID",
      value: "id",
      sortable: false,
      width: "90px",
    },
    {
      text: "Talep Durum",
      value: "status_txt",
      align: "left px-4 px-lg-3",
      sortable: false,
      width: "200px",
    },
    {
      text: "Şube",
      value: "created_by",
      align: "left px-4 px-lg-3",
      width: 130,
      sortable: false,
    },
    {
      text: "Talep Eden",
      value: "pers_display_name",

      sortable: false,
    },

    {
      text: "Tutar (TL)",
      value: "genamount",
      align: "right pl-0 pr-3 px-lg-3",
      sortable: false,
      width: "100px",
    },
    {
      text: "Kalem",
      align: "center pl-0 pr-3 px-lg-3",
      value: "kalem_sayisi",
      width: "80px",
      sortable: false,
    },
    {
      text: "Kayıt Tarihi",
      value: "created_date",
      align: "right",
      sortable: false,
      width: "150px",
    },
    {
      text: "",
      value: "actions",
      sortable: false,
      width: "150px",
    },
  ]);

  // Table Load More
  const tablePage = ref(1);
  const loadMoreLoading = ref(false);
  const loadMore = (isIntersecting) => {
    if (isIntersecting) {
      tablePage.value++;
      tableOptions.value.page = tablePage.value;
      if (!tableLoading.value) {
        tableFetch();
      }
    }
  };

  // Tablo Arama
  const tableReFetch = ref(false);
  const tableSearchID = ref("");
  const tableSearchStatu = ref("");
  const tableSearchUser = ref("");
  const tableSearchUserNo = ref("");
  const tableSearchFormDateMenu = ref(false);
  const tableSearchFormDate = ref("");
  const tableEmptySearch = ref(4);
  const tableOptions = ref({
    sortBy: ["id"],
    sortDesc: [true],
  });

  const debouncedTableSearch = useDebounceFn(() => {
    tableFetch();
  }, 700);

  // Tarih aralığı için değişiklikler izleniyor
  const tableRangeDate = ref({
    start: null,
    end: null,
    text: null,
    value: "all",
  });

  // Durum listesi
  const getExpenseStatusList = ref([]);
  const cacheStatusGet = async () => {
    const request = {
      method: "expenseStatusList",
    };
    const { response, error } = await postData(request);

    if (error) {
      return;
    }

    getExpenseStatusList.value = response.map((item) => {
      return {
        text: item.stext,
        value: item.code,
      };
    });
  };

  // API İstek
  const tableFetch = () => {
    tableLoading.value = true;
    const request = {
      method: "getExpenseList",
      options: JSON.stringify(tableOptions.value),
    };

    if (tableRangeDate.value.value != "all") {
      request["search[t.startdate]"] = tableRangeDate.value.start;
      request["search[t.enddate]"] = tableRangeDate.value.end;
    }

    if (tableSearchID.value) {
      request["search[t.id]"] = tableSearchID.value;
    }
    if (tableSearchUser.value) {
      request["search[t.hazirlayan_adsoyad]"] = tableSearchUser.value;
    }
    if (tableSearchUserNo.value) {
      request["search[t.hazirlayan_sicilno]"] = tableSearchUserNo.value;
    }
    if (tableSearchStatu.value) {
      request["search[t.status]"] = tableSearchStatu.value;
    }
    if (tableSearchFormDate.value) {
      request["search[t.form_date]"] = tableSearchFormDate.value;
    }

    postData(request)
      .then((response) => {
        // API dönüşündeki hatalara bakıyoruz
        if (response.error) {
          throw new Error(response.msg);
        }

        // Toplam kayıt sayısı işleniyor

        tableTotalRec.value = Number(response.response.pagination.totalRec);

        // Responseda bir değer yoksa
        if (response.response.result.length === 0) {
          loadMoreLoading.value = false;
          return;
        }

        // Responsedan gelen veriler işleniyor
        response.response.result.map((item) => {
          tableItems.value.push({ ...item, kalem_sayisi: item.expense_lines.length });
        });

        console.log(tableItems.value);

        loadMoreLoading.value = false;
        if (tableTotalRec.value >= 20) {
          setTimeout(() => {
            loadMoreLoading.value = true;
          }, 300);
        }
      })
      .catch((e) => {
        // API hataya girdi
        toast.error(e.message, {
          position: "bottom-center",
        });
      })
      .finally(() => {
        // API işlemi bittikten sonra
        tableLoading.value = false;
        startPage.value = false;
      });
  };

  // Search Clear
  const searchClear = () => {
    tablePage.value = 1;
    tableOptions.value.page = 1;
    tableSearchID.value = null;
    tableReFetch.value = !tableReFetch.value;
  };

  // Add Edit Emit
  const handleAddEdit = (val) => {
    if (!val) return;
    searchClear();
  };

  const setupTableWatchers = () => {
    // Tablo arama alanlarını izle
    watch(
      [
        tableSearchID,
        tableSearchStatu,
        tableSearchFormDate,
        tableReFetch,
        tableSearchUser,
        tableSearchUserNo,
      ],
      () => {
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // Tarih aralığı için değişiklikleri izle
    watch(
      () => pageStore.dateRange,
      (newVal) => {
        tableRangeDate.value = newVal;
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );
  };

  const initTable = async () => {
    await cacheStatusGet();
    startPage.value = true;
    tableFetch();
  };

  return {
    tableLoading,
    tableItems,
    tableTotalRec,
    tableColumns,
    loadMore,
    loadMoreLoading,
    tableFetch,
    tableEmptySearch,
    tableOptions,
    tableSearchID,
    tableSearchStatu,
    tableSearchUser,
    tableSearchUserNo,
    tableSearchFormDateMenu,
    tableSearchFormDate,
    handleAddEdit,
    getExpenseStatusList,
    cacheStatusGet,
    initTable,
    setupTableWatchers,
    searchClear,
    startPage,
    icons: {
      mdiMagnify,
      mdiCalendarClock,
      mdiUpload,
    },
  };
}
